import { render, staticRenderFns } from "./PendingClaimsApprovals.vue?vue&type=template&id=693cc43e"
import script from "./PendingClaimsApprovals.vue?vue&type=script&lang=js"
export * from "./PendingClaimsApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports